module.exports = __webpack_public_path__ + "media/account.10e01f5b.mp4";